import { FormType } from "../../../common/enums/sharedEnums";
import { FormTypeText } from "../interfaces";

export const ADD_DWELLING = 'ADD_DWELLING';
export const ADD_DWELLING_SUCCESS = 'ADD_DWELLING_SUCCESS';
export const ADD_DWELLING_FAILED = 'ADD_DWELLING_FAILED';

export const GET_DWELLING = 'GET_DWELLING';
export const GET_DWELLING_SUCCESS = 'GET_DWELLING_SUCCESS';
export const GET_DWELLING_FAILED = 'GET_DWELLING_FAILED';

export const GET_DWELLINGS = 'GET_DWELLINGS';
export const GET_DWELLINGS_SUCCESS = 'GET_DWELLINGS_SUCCESS';
export const GET_DWELLINGS_FAILED = 'GET_DWELLINGS_FAILED';

export const UPDATE_DWELLING = 'UPDATE_DWELLING';
export const UPDATE_DWELLING_SUCCESS = 'UPDATE_DWELLING_SUCCESS';
export const UPDATE_DWELLING_FAILED = 'UPDATE_DWELLING_FAILED';

export const GET_DWELLING_SERVICES = 'GET_DWELLING_SERVICES';
export const GET_DWELLING_SERVICES_SUCCESS = 'GET_DWELLING_SERVICES_SUCCESS';
export const GET_DWELLING_SERVICES_FAILED = 'GET_DWELLING_SERVICES_FAILED';

export const UPLOAD_DWELLING_FILES = 'UPLOAD_DWELLING_FILES';
export const UPLOAD_DWELLING_FILES_SUCCESS = 'UPLOAD_DWELLING_FILES_SUCCESS';
export const UPLOAD_DWELLINGS_FILES_FAILED = 'UPLOAD_DWELLINGS_FILES_FAILED';

export const REMOVE_DWELLING_FILE = 'REMOVE_DWELLING_FILE';
export const REMOVE_DWELLING_FILE_SUCCESS = 'REMOVE_DWELLING_FILE_SUCCESS';
export const REMOVE_DWELLING_FILE_FAILED = 'REMOVE_DWELLING_FILE_FAILED';

export const GET_DWELLING_SERVICES_INVENTORY = 'GET_DWELLING_SERVICES_INVENTORY';
export const GET_DWELLING_SERVICES_INVENTORY_SUCCESS = 'GET_DWELLING_SERVICES_INVENTORY_SUCCESS';
export const GET_DWELLING_SERVICES_INVENTORY_FAILED = 'GET_DWELLING_SERVICES_INVENTORY_FAILED';


export const formTypeText: Record<FormType, FormTypeText> = {
  [FormType.CREATE]: {
    title: "J'ajoute un nouveau bien",
    success: "Nouveau bien enregistré",
    error:
      "Le nouveau bien n'est pas enregistré, veuillez corriger les erreurs du formulaire",
  },
  [FormType.UPDATE]: {
    title: "Modifier un bien",
    success: "La modification du bien a été enregistré",
    error:
      "La modification du bien n'a pas été enregistrée, veuillez corriger les erreurs du formulaire",
  },
};
